module.exports = __webpack_public_path__ + "static/media/submittedIcon.d0867f1e.svg";